<div class="app-view">
    <!-- <mat-toolbar style="width: 100vw; height: 5vh;"></mat-toolbar> -->
    <router-outlet></router-outlet>
    <!-- <mat-toolbar style="width: 100vw; height: 5vh;"></mat-toolbar> -->
</div>
